import GenericFooter from "../../generic/components/GenericFooter";

export default function PlusCareFooter() {
    return (
        <GenericFooter companyName="Plus Care s.r.o." companyUrl="https://www.pluscare.cz" email="info@pluscare.cz" />
    );
}
